import { FC } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { CustomerCard } from 'components/Card'
import styles from 'styles/components/template.module.scss'
import { GreyButton } from 'components/Button'
import { Spacer } from 'components/Utility'

type Props = {
  userId: string
}

const CustomerTemplate: FC<Props> = (props) => {
  const { userId } = props
  const dispatch = useDispatch()

  return (
    <div className={styles.standard}>
      <Spacer size={20} />
      <CustomerCard userId={userId} isShownByModal={false} />
      <Spacer size={40} />
      <GreyButton
        label={'お客さまリストに戻る'}
        onClick={() => dispatch(push('/customer'))}
        size={'medium'}
        type={'outlined'}
      />
      <Spacer size={36} />
    </div>
  )
}

export default CustomerTemplate
